import React, { useCallback, useState } from "react";
import * as styles from "./ReadMore.module.scss";
import clsx from "clsx";
import { Button } from "@silversea-ssc/ui-components-react";
import { BackgroundColor } from "types/componentBackground";

interface ReadMoreProps {
  openLabel: string | JSX.Element;
  closeLabel: string | JSX.Element;
  className?: string;
  height?: string;
  backgroundColor?: BackgroundColor;
  enableInDesktop?: boolean;
  hideCloseButton?: boolean;
}

const ReadMore: React.FC<React.PropsWithChildren<ReadMoreProps>> = ({
  openLabel,
  closeLabel,
  className = undefined,
  height = "150px",
  children,
  backgroundColor = "white",
  enableInDesktop = false,
  hideCloseButton = false
}) => {
  const [expanded, setExpanded] = useState(false);
  const close = useCallback(() => setExpanded((e) => !e), []);

  return (
    <div
      className={clsx(className, {
        [styles.expanded]: expanded,
        [styles.onlyMobile]: !enableInDesktop,
        [styles.backgroundWhite]: backgroundColor == "white",
        [styles.backgroundGray]: backgroundColor == "neutral05",
        [styles.hideCloseButton]: hideCloseButton
      })}
    >
      <div
        className={styles.content}
        style={{ maxHeight: expanded ? "auto" : height }}
      >
        {children}
      </div>

      <Button
        renderAs="button"
        className={styles.button}
        variant="inline-text"
        iconName={expanded ? "close" : "plus"}
        onClick={close}
        dataContentPiece={
          expanded ? `read-more-button-close` : `read-more-button-expand`
        }
      >
        {expanded ? closeLabel : openLabel}
      </Button>
    </div>
  );
};

export default ReadMore;
